let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dZkdz")).then(() => parcelRequire('S4YmJ'));